import axios from "axios";
import React, { useEffect, useState } from "react";
import * as Constants from "../../constants/urls";
import { useCookies } from "react-cookie";
import Pagination from "react-js-pagination";
import { Link } from "react-router-dom";
import Loading from "../Loading/Loading";
import Header from "../Header/Header";
import { Drawer } from "@material-ui/core";
import RightMenu from "../RightMenu";
const QueueHandler = (props) => {
    const [data, setDate] = useState(undefined);
    const [orderIdFilter, setorderIdFilter] = useState("");
    const [usernameFilter, setusernameFilter] = useState("");
    const [loading, setLoading] = useState(false);
    const [cookies, setCookie, removeCookie] = useCookies();
    const [state, setState] = useState({ right: false });

    const toggleDrawer = (anchor, open) => (event) => {
        if (
            event.type === "keydown" &&
            (event.key === "Tab" || event.key === "Shift")
        ) {
            return;
        }
        setState({ ...state, [anchor]: open });
    };

    function getLogs(page) {
        setLoading(true);
        const url = Constants.apiUrl + "/api/failedOrder";
        axios
            .post(
                url,
                {
                    page: page,
                    orderId: orderIdFilter,
                    username: usernameFilter,
                },
                {
                    headers: {
                        Authorization: "Bearer " + cookies.user_server_token,
                    },
                },
            )
            .then((r) => {
                setDate(r.data);
                setLoading(false);
            })
            .catch((e) => {
                // if(e.response.status==403)
                // {
                //     window.location="403";
                // }
            });
    }
    function failedOrderRestart(e) {
        setLoading(true);
        let id = e.target.attributes.id.value;

        const url = Constants.apiUrl + "/api/failedOrderRestart";
        axios
            .post(
                url,
                { id: id },
                {
                    headers: {
                        Authorization: "Bearer " + cookies.user_server_token,
                    },
                },
            )
            .then((r) => {
                setLoading(false);
                getLogs(data.current_page);
            })
            .catch((e) => {
                setLoading(false);
            });
    }

    useEffect(() => {
        getLogs(1);
    }, []);

    const statusHandler = (status) => {
        let title = "عملیات انجام شده است";
        if (status == 1) title = "عملیات انجام نشده است";
        return title;
    };
    const checksubmit = (e) => {
        if (e.key === "Enter") {
            getLogs(1);
        }
    };
    const statusFilter = (e) => {
        console.log(e.target.value);
    };

    return (
        <React.Fragment>
            <Header
                title=" عملیات های ناموفق ثبت سفارش"
                menuItemClicked={toggleDrawer("right", true)}
            />
            <Drawer
                anchor="right"
                open={state["right"]}
                onClose={toggleDrawer("right", false)}
            >
                <RightMenu />
            </Drawer>

            {loading && <Loading />}
            <div className="mt-2">
                <table className="table table-hover ">
                    <thead className="">
                        <tr className="bg-primary text-white">
                            <th scope="col">شماره سفارش</th>
                            <th scope="col">کاربر</th>
                            <th scope="col">وضعیت</th>
                            <th scope="col">عملیات</th>
                        </tr>
                        <tr className="bg-dark text-white">
                            <th scope="col">
                                <input
                                    type="text"
                                    value={orderIdFilter}
                                    onChange={(e) => {
                                        setorderIdFilter(e.target.value);
                                    }}
                                    onKeyDown={checksubmit}
                                />
                            </th>
                            <th scope="col">
                                <input
                                    type="text"
                                    value={usernameFilter}
                                    onChange={(e) => {
                                        setusernameFilter(e.target.value);
                                    }}
                                    onKeyDown={checksubmit}
                                />
                            </th>
                            <th scope="col">
                                <select
                                    className="form-control"
                                    onChange={statusFilter}
                                >
                                    <option value={""}>انتخاب کنید</option>
                                    <option value={1}>پردازش نشده </option>
                                    <option value={0}>پردازش شده </option>
                                </select>
                            </th>
                            <th scope="col"> </th>
                        </tr>
                    </thead>
                    <tbody>
                        {data &&
                            data.data &&
                            data.data.map((item, index) => {
                                return (
                                    <tr>
                                        <td>{item.order_id}</td>
                                        <td>{item.operator.username}</td>
                                        <td
                                            className={
                                                item.status == 0
                                                    ? "text-success"
                                                    : "text-danger"
                                            }
                                        >
                                            {statusHandler(item.status)}
                                        </td>
                                        <td>
                                            <button
                                                className="btn btn-primary"
                                                disabled={
                                                    item.status == 0
                                                        ? "disabled"
                                                        : ""
                                                }
                                                id={item.id}
                                                onClick={failedOrderRestart}
                                            >
                                                اجرای عملیات
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })}
                    </tbody>
                </table>

                <div className="pager Page navigation example">
                    {data && (
                        <Pagination
                            totalItemsCount={data.total}
                            activePage={data.current_page}
                            itemsCountPerPage={data.per_page}
                            onChange={(number) => {
                                getLogs(number);
                            }}
                            itemClass="page-item"
                            linkClass="page-link"
                            firstPageText="اولین صفحه"
                            lastPageText="آخرین صفحه"
                            nextPageText="بعدی"
                            prevPageText="قبلی"
                            activeClass="pageactive"
                        />
                    )}
                </div>
            </div>
        </React.Fragment>
    );
};
export default QueueHandler;
